<template>
    <footer
        data-testid="footer-auth"
        :class="[
            'flex mb-12',
            {
                'flex-col gap-y-3': arrangementIsVertical,
                'gap-x-8': arrangementIsHorizontal,
            },
        ]"
    >
        <LocaleSwitcher />
        <FooterAuthLinks :center-aligned="linksCentered" />
    </footer>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import LocaleSwitcher from '@/components/LocaleSwitcher';
import type { EnumToUnion } from '@/types/misc';
import FooterAuthLinks from './FooterAuthLinks.vue';
import { FooterAuthArrangement } from './FooterAuth';

/**
 * This footer is responsive on its own and will make itself fit for most situations out of the box :)
 */
export default defineComponent({
    name: 'FooterAuth',
    components: {
        LocaleSwitcher,
        FooterAuthLinks,
    },
    props: {
        /**
         * Specifies the direction in which the footer's contents are laid out.
         * Either vertically or horizontally.
         */
        arrangement: {
            type: String as PropType<EnumToUnion<FooterAuthArrangement>>,
            required: true,
        },
        /**
         * Specifies if the links should be centered
         */
        linksCentered: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        arrangementIsVertical(): boolean {
            return this.arrangement === FooterAuthArrangement.VERTICAL;
        },
        arrangementIsHorizontal(): boolean {
            return this.arrangement === FooterAuthArrangement.HORIZONTAL;
        },
    },
});
</script>

<style lang="scss" scoped></style>
